module.exports = __webpack_public_path__ + "fonts/quicksand-v20-latin-700.a83eb886.eot";